import tonStyles from './../ton.json'

export default {
  borderBottom: `1px solid ${tonStyles.colors.PrimaryGrey}`,
  scrollContainerMarginLeft: {
    small: '-16px',
    medium: '0px',
    large: '-4px'
  },
  sticky: {
    small: {
      offset: '46px'
    },
    medium: {
      marginTop: 0
    },
    large: {
      marginTop: 0
    }
  }
}
